import whatsapp_icon from "../../assets/icons/whatsapp_green.svg";
import React, { useEffect, useState } from 'react';
import { Tooltip } from 'react-tooltip';
import { AiOutlineQuestionCircle } from "react-icons/ai";
import DateRange from "../Form/components/DateRange";
import OptionSelect from "../Form/components/OptionSelect";
import { Trip } from "../../types/trip";

interface PriceBoxProps {
    numPassengers: number;
    setNumPassengers?: (value: number) => void;
    quotation: Trip;
    handleSubmit: () => void;
    handlePhoneClick: () => void;
    handleSpecialPriceClick: () => void;
    isOrderLoading: boolean;
    isReservation: boolean;
    onDateChange?: (date: string) => void;
    onOptionChange?: (option: string) => void;
    label?: string;
    selectedDate?: string;
    isValid?: boolean;
    setIsValid?: (value: boolean) => void;
    isOptionValid?: boolean;
    setIsOptionValid?: (value: boolean) => void;
    specialPrice?: boolean;
    haveOptions?: boolean | null;
    options?: Array<{ value: string }>;
    isExperience?: boolean;
}


const PriceBox = ({
    numPassengers,
    setNumPassengers,
    quotation,
    handleSubmit,
    handlePhoneClick,
    handleSpecialPriceClick,
    isOrderLoading,
    isReservation,
    onDateChange = (date) => {
    },
    onOptionChange = (option) => {
    },
    label = 'Reservar ahora',
    selectedDate,
    isValid,
    setIsValid,
    isOptionValid,
    setIsOptionValid,
    specialPrice = false,
    haveOptions = false,
    options = [],
    isExperience
}: PriceBoxProps) => {
    const MAX_NUM_PASSENGERS = 10;
    const [isSmallScreen, setIsSmallScreen] = useState(false);


    const handleAddPassenger = () => {
        const maxPassengers = Math.min(quotation.stock, MAX_NUM_PASSENGERS);
        if (numPassengers < maxPassengers) {
            setNumPassengers((prev) => prev + 1);
        }
    };

    const handleRemovePassenger = () => {
        if (numPassengers > 1) {
            setNumPassengers((prev) => prev - 1);
        }
    };


    useEffect(() => {
        setIsSmallScreen(window.innerWidth <= 768);

        const handleResize = () => {
            setIsSmallScreen(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isSmallScreen]);

    return (
        <div className="pricebox__container">
            <div className="quotation-details__container">
                {!isSmallScreen && (<div className="quotation-price">
                    <div className="h2">
                        <h2>
                            {quotation.price.currency} {quotation.price.value}
                        </h2>
                        <span>por persona</span>
                    </div>
                </div>)}
                <div className="num-people__container">
                    <span>Cantidad de personas</span>
                    <div className="num-people__actions">
                        {setNumPassengers && (
                            <button onClick={handleRemovePassenger}>
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip0_225_460)">
                                        <path
                                            d="M6 12H18"
                                            stroke="#83868C"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_225_460">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </button>
                        )}
                        <span style={!setNumPassengers ? { marginRight: "3rem" } : {}}>
                            {numPassengers}
                        </span>
                        {setNumPassengers && (
                            <button onClick={handleAddPassenger}>
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clipPath="url(#clip0_225_466)">
                                        <path
                                            d="M12 12V18M6 12H12H6ZM18 12H12H18ZM12 12V6V12Z"
                                            stroke="#1B1C1E"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_225_466">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </button>
                        )}
                    </div>
                </div>
                {(isExperience) && (
                    <div className="datePicker__container">
                        {(quotation?.available_time_spots && quotation?.available_time_spots.length) ? (
                            <p>Selecciona una fecha y horario</p>
                        ) : (
                            <p>Selecciona una fecha</p>
                        )}

                        <DateRange value={selectedDate} onDataChange={onDateChange} isValid={isValid}
                            setIsValid={setIsValid}
                            availableTimes={quotation?.available_time_spots && quotation?.available_time_spots.length ? quotation?.available_time_spots : []} />
                    </div>
                )}
                {(haveOptions) && (
                    <div className="options__container">
                        <p>Selecciona una opción</p>

                        <OptionSelect options={options} onOptionChange={onOptionChange} isValid={isOptionValid}
                            setIsValid={setIsOptionValid}></OptionSelect>
                    </div>
                )}
                {isReservation && (
                    <div className="reservation__container">
                        <div className="reservation__container__total">
                            <div className="total-text">
                                <h3>Total</h3>
                            </div>
                            <div className="total-price">
                                <h3>{quotation.price.currency} {numPassengers * quotation.price.value}</h3>
                            </div>
                        </div>
                        <div className="reservation__container__reservation">
                            <div className="reservation-text">
                                <h2>A pagar ahora</h2> <AiOutlineQuestionCircle className="due_now_tooltip_btn" />
                                <Tooltip
                                    anchorSelect=".due_now_tooltip_btn"
                                    className="due_now_tooltip"
                                    place="bottom"
                                >
                                    {['7e5a631b-ff0b-4f66-9d2a-59451931c679', '7e5a631b-ff0b-4f66-9d2a-59451931c879'].includes(quotation.id) ? (
                                        <>
                                            {/* Viaje grupal a Egipto 2025, Fio y Chris. */}
                                            <p> La confirmación del viaje queda sujeta a alcanzar el cupo mínimo.<br /><br />
                                                En caso de no hacerlo hasta el <span> 09/08/25 </span> se devolverá el 100% de la seña.</p>
                                        </>
                                    ) : (
                                        <p> Asegura tu lugar con un pago <span> no reembolsable </span>
                                            de <span>{quotation.price.currency} {numPassengers * quotation.price.min_amount}</span>.<br /><br />
                                            Recibirás la información para pagar el saldo restante en el correo de
                                            confirmación.</p>
                                    )}
                                </Tooltip>
                            </div>
                            <div className="reservation-price">
                                <h2>{quotation.price.currency} {numPassengers * quotation.price.min_amount}</h2>
                            </div>
                        </div>
                    </div>
                )}
                {!isReservation && (
                    <div className="total__container">
                        <div className="total-text">
                            <h2>Total</h2>
                        </div>
                        <div className="total-price">
                            <h2>{quotation.price.currency} {numPassengers * quotation.price.value}</h2>
                            <span>Todos los impuestos y cargos incluidos</span>
                        </div>
                    </div>
                )}
                <div className="checkout-actions">
                    {isOrderLoading ? (<div className="order-loader"></div>) : (
                        <button type="button"
                            onClick={
                                quotation.stock > 0 ?
                                    handleSubmit
                                    : () => { }
                            }
                            disabled={quotation.stock === 0}
                        >
                            {label}
                        </button>)}
                </div>
            </div>
            {!specialPrice && (
                <div className="phone" onClick={handlePhoneClick}>
                    <span>¿Tienes dudas?</span>
                    <img className="wp_img" src={whatsapp_icon} alt="icono de whatsapp" />
                </div>
            )}
            {specialPrice && (
                <div className="phone phone--grey" onClick={handleSpecialPriceClick}>
                    <span>¿Sos jubilado o residente? Escribime!</span>
                </div>
            )}
        </div>
    );
};

export default PriceBox;